import RoleCombobox from "./combobox.js"

export default RoleCombobox

RoleCombobox.define()
export * from './combobox.js';

/**
 * @type {import("./combobox-globals.js")}
 */
